import Card, { type CardProps } from '@mui/material/Card';
import { styled } from '@mui/material/styles';

const StyledCard = styled(Card)(({ theme }) => ({
  width: '100%',
  textAlign: 'left',
  boxSizing: 'border-box',

  '&.kmx-car-tile:hover': {
    backgroundColor: '#F3F3F5',
  },

  '&:focus': {
    outline: `solid ${theme.palette.info.dark}`,
  },

  '.kmx-car-tile__favorite-button': {
    fontSize: '1.5rem',
    position: 'absolute',
    right: '0.5rem',
    top: '0.5rem',
    zIndex: 2,
  },

  '.MuiCardMedia-root': {
    aspectRatio: '5 / 3',
    width: '100%',

    '> a': {
      display: 'block',
      height: '100%',
      width: '100%',

      '> img': {
        height: '100%',
        objectFit: 'cover',
        width: '100%',
      },
    },
  },

  '&.kmx-car-tile-skeleton': {
    '.kmx-car-tile-skeleton__media .MuiSkeleton-root': {
      aspectRatio: '5 / 3',
      height: 'auto',
      width: '100%',
    },
  },
}));

type CarTileCardProps = CardProps;

const CarTileCard = ({ children, className, ...rest }: CarTileCardProps) => (
  <StyledCard {...rest} className={className} tabIndex={0}>
    {children}
  </StyledCard>
);

export default CarTileCard;
